<app-modal-base [title]="dialogTitle" (onSubmitEvent)="onSubmit()" [loading]="isLoading" [isDisabled]="form.invalid">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <p>{{'connectorConfigDialog.'+data.connectorCode+'_helpLine1' | translate }}</p>
    <p>{{'connectorConfigDialog.'+data.connectorCode+'_helpLine2' | translate }}</p>
    <p>{{'connectorConfigDialog.'+data.connectorCode+'_helpLine3' | translate }}</p>
    <div class="formContainer d-flex justify-content-center">
      <form [formGroup]="form" class="col-12">
        <div class="form-group row">
          <app-input size="12" [label]="'connectorConfigDialog.'+data.connectorCode+'_clientId'"
            [formControl]="form_clientId">
          </app-input>
        </div>
        <div class="form-group row">
          <app-input size="12" [label]="'connectorConfigDialog.'+data.connectorCode+'_token'"
            [formControl]="form_token">
          </app-input>
        </div>
      </form>
    </div>
  </div>
</ng-template>
